import { z } from 'zod';

const requiredMessage = 'Birthday (MM/DD/YYYY) is required';
const invalidMessage = 'Please enter a valid date in the format MM/DD/YYYY';
const invalidYearMessage = 'Year must be later than 1969';

export const birthDateSchema = z
    .string({
        message: requiredMessage,
    })
    .superRefine((value, ctx) => {
        const [month, day, year] = value.split('/').map(Number);
        const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;
        const date = new Date(year, month - 1, day);

        // required
        if (!value) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: requiredMessage,
            });
        }

        // invalid year
        if (year < 1970) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: invalidYearMessage,
            });
        }

        // invalid format
        if (!datePattern.test(value)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: invalidMessage,
            });
        }

        // invalid date
        if (
            date.getFullYear() !== year ||
            date.getMonth() !== month - 1 ||
            date.getDate() !== day ||
            date.getTime() > new Date().getTime()
        ) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: invalidMessage,
            });
        }
    });
